<template>
  <div class="model">
    <a-modal title="批量设置" :visible="popupVisible" width="750px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="{ span: 4 }" :wrapper-col="{ span: 20}">
        <a-form-model-item label="选择时间段" prop="dateTime">
          <a-range-picker name="buildTime" :disabledDate="disabledDate"
                          v-model="ruleForm.dateTime"
                          @change="onDateChange"
                          format="YYYY-MM-DD"/>
        </a-form-model-item>
        <a-form-model-item label="日期模式" prop="dayMode">
          <a-radio-group v-model="ruleForm.dayMode">
            <a-radio :value="1">仅单日</a-radio>
            <a-radio :value="2">仅双日</a-radio>
            <a-radio :value="3">按星期</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="适用星期" prop="week" v-if="ruleForm.dayMode==3">
          <a-checkbox-group v-model="ruleForm.week" :options="plainOptions" @change="onCheckChange"/>
          <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
        </a-form-model-item>
        <a-row :span="10">
          <a-col :span="12">
            <a-form-model-item v-bind="popuplayout" label="同行价" prop="mfAuditPrice">
              <a-input v-model="ruleForm.mfAuditPrice" placeholder="请输入" addon-after="元"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-bind="popuplayout" label="建议销售价" prop="advicePrice">
              <a-input v-model="ruleForm.advicePrice" placeholder="请输入" addon-after="元"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :span="10">
          <a-col :span="12">
            <a-form-model-item v-bind="popuplayout" label="市场价" prop="marketPrice">
              <a-input v-model="ruleForm.marketPrice" placeholder="请输入" addon-after="元"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-bind="popuplayout" label="分销佣金" prop="commissionPrice">
              <a-input v-model="ruleForm.commissionPrice" placeholder="请输入" addon-after="元"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :span="10">
          <a-col :span="12">
            <a-form-model-item v-bind="popuplayout" label="采购价" prop="purchasePrice">
              <a-input v-model="ruleForm.purchasePrice" placeholder="请输入" addon-after="元"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :span="10">
          <a-col :span="12">
            <a-form-model-item v-bind="popuplayout" label="分销改价权限">
              <a-select v-model="ruleForm.distAdjust" placeholder="请选择">
                <a-select-option :value="1">不可调整</a-select-option>
                <a-select-option :value="2">不可低于建议销售价</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-bind="popuplayout" label="是否二次确认">
              <a-select v-model="ruleForm.priceConfirm" placeholder="请选择">
                <a-select-option :value="0">不需要二次确认</a-select-option>
                <a-select-option :value="1">需要二次确认</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :span="10">
          <a-col :span="12">
            <a-form-model-item v-bind="popuplayout" label="库存" prop="stock">
              <a-input v-model="ruleForm.stock" placeholder="请输入库存"></a-input>
            </a-form-model-item>
          </a-col>
          <!--          <a-col :span="12">-->
          <!--            <a-form-model-item v-bind="popuplayout" label="是否共享库存">-->
          <!--              <a-select v-model="ruleForm.isShare" placeholder="请选择">-->
          <!--                <a-select-option :value="0">不共享</a-select-option>-->
          <!--                <a-select-option :value="1">共享</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-model-item>-->
          <!--          </a-col>-->
        </a-row>
        <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
          <a-button @click="handleCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PriceVolumeSet',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    proId: {
      type: [String, Number],
      default: 0
    },
    optionId: {
      type: [String, Number],
      default: 0
    },
    ratePlanId: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    var checkAdvicePrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.mfAuditPrice)) {
          callback(new Error('销售价大于或等于同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkCommissionPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Math.round(Math.round(Number(this.ruleForm.advicePrice) * 100) - Math.round(Number(this.ruleForm.mfAuditPrice) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
          callback(new Error('必须小于销售价减同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      ruleForm: {
        dateTime: undefined,
        dayMode: '',//日期模式 1 单日 2 双日 3. 按星期
        advicePrice: '', //建议销售价;建议销售成人价
        commissionPrice: '', //佣金
        startEndDate: '', //日期
        priceConfirm: 1, // 是否需要再次确认 0 不需要 1 需要 ,
        marketPrice: '', //市场价 ;市场成人价 ,
        distAdjust: 1, // 分销价格调整权限 0 自有调整 1 不可调整 2 不可低于建议销售价 ,
        mfAuditPrice: '', //同行价;成人同行价
        optionId: this.optionId, //
        productId: this.proId,
        ratePlanId: this.ratePlanId,
        purchasePrice: '', //采购价;采购成人价
        stock: '', //库存
        week: []
      },
      popuplayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      rules: {
        dateTime: [
          { required: true, message: '请选择时间段', trigger: 'change' }
        ],
        dayMode: [
          { required: true, message: '请选择日期模式', trigger: 'change' }
        ],
        week: [
          { type: 'array', required: true, message: '请选择适用星期', trigger: 'change' }
        ],
        mfAuditPrice: [
          { required: true, message: '请输入同行价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        advicePrice: [
          { required: true, message: '请输入建议销售价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          },
          { validator: checkAdvicePrice, trigger: 'blur' }
        ],
        marketPrice: [
          { required: true, message: '请输入市场价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        purchasePrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        commissionPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkCommissionPrice, trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '请输入库存', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,5}$/, message: '请输入正确的库存', trigger: 'blur' }
        ]
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      plainOptions: [{ label: '周一', value: 1 }, { label: '周二', value: 2 }, {
        label: '周三',
        value: 3
      }, { label: '周四', value: 4 },
        { label: '周五', value: 5 }, { label: '周六', value: 6 }, { label: '周日', value: 7 }
      ],
      indeterminate: false,
      checkAll: false,
      checkedIdList: [1, 2, 3, 4, 5, 6, 7],
      popupVisible: false,
      submitLoading: false
    }
  },
  watch: {
    visible(val) {
      this.popupVisible = val
    },
    ratePlanId(val) {
      this.ruleForm.ratePlanId = val
    }
  },
  mounted() {
    this.popupVisible = this.visible
    this.ruleForm.optionId = this.optionId
    this.ruleForm.productId = this.proId
    this.ruleForm.ratePlanId = this.ratePlanId
  },
  methods: {
    //变价时段
    onDateChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateChange', dates)
      this.getLogUtils().logWithTag('onDateChange', dateStrArr)
      this.ruleForm.dateTime = dates
      this.ruleForm.startEndDate = dateStrArr.join(',')
      this.ruleForm = { ...this.ruleForm }
    },
    onCheckChange(checkedList) {
      this.getLogUtils().logWithTag('onChange===', checkedList)
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    onCheckAllChange(e) {
      this.getLogUtils().logWithTag('onCheckAllChange===', e)
      this.ruleForm.week = e.target.checked ? this.checkedIdList : []
      this.checkAll = e.target.checked
      this.indeterminate = false
      this.getLogUtils().logWithTag('数据===', this.ruleForm.week)
    },
    handleCancel() {
      this.$emit('changeClose')
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.week = this.submitFormData.week.join(',')
      delete this.submitFormData.dateTime
      this.getHttpServices().getProService().post('api/v2/productManage/hotel/price-plan/batch/price-stock', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('批量价格设置成功')
        this.$emit('changeUpdate')
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style lang="less" scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}
</style>